import useConfirmPayment from '@frontend/features/confirm-payment/hooks/useConfirmPayment'
import { ImageSize } from '@frontend/libs/types/media'
import { Button, Image } from '@nextui-org/react'
import { __ } from '@wordpress/i18n'
import { useState } from 'react'

import ConfirmPaymentForm from './ConfirmPaymentForm'

export interface ConfirmPaymentProps {
  orderId: number
}

export function ConfirmPayment({ orderId }: ConfirmPaymentProps): JSX.Element {
  const { data, error, isLoading } = useConfirmPayment().getBankAccount()
  const [showForm, setShowForm] = useState(false)

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error: {error?.message}</div>
  }

  return (
    <section>
      <h2 className="mb-4 font-medium uppercase">
        {__('Our bank details', 'asavagroup')}
      </h2>
      {data?.map((bank) => (
        <div
          className="md:[&amp;>*:not(:first-child)]:pl-10 space-y-6 md:flex md:space-x-10 md:space-y-0 md:divide-x"
          key={bank.bankName}
        >
          <div>
            <Image
              alt={bank.bankLogo.alt}
              src={bank.bankLogo.sizes[ImageSize.Medium]}
              width={40}
            />
          </div>
          <div>
            <h4 className="mb-2 font-medium">{__('Bank', 'asavagroup')}</h4>
            {bank.bankName}
          </div>
          <div>
            <h4 className="mb-2 font-medium">
              {__('Account number', 'asavagroup')}
            </h4>
            {bank.accountNumber}
          </div>
          <div>
            <h4 className="mb-2 font-medium">
              {__('Account name', 'asavagroup')}
            </h4>
            {bank.accountName}
          </div>
        </div>
      ))}
      <div className="mt-20 text-center">
        <p className="mb-2 uppercase">
          {__(
            'Finalize Your Payment, Please confirm your bank transfer here',
            'asavagroup',
          )}
        </p>
        {!showForm && (
          <Button
            color="primary"
            onPress={() => setShowForm(true)}
            type="button"
            variant="solid"
          >
            {__('Confirm payment', 'asavagroup')}
          </Button>
        )}
      </div>
      {showForm && (
        <div className="mt-6 bg-default-50 p-6">
          <ConfirmPaymentForm orderId={orderId} />
        </div>
      )}
    </section>
  )
}

export default ConfirmPayment
